// i.e: "Jan 31, 2050, 02:46 PM"
export const DATE_TIME_FORMAT = "MMM DD, YYYY, hh:mm A";

// i.e: "Wed, Jan 31, 2050, 02:46 PM"
export const WEEKDAY_DATE_TIME_FORMAT = "ddd, MMM DD, YYYY, hh:mm:ss A";

// i.e: "Wed, Jan 31, 2:46 PM"
export const WEEKDAY_SHORT_DATE_TIME_FORMAT = "ddd, MMM D, hh:mm A";

// // i.e.: "Mon, Feb 08"
// export const WEEKDAY_SORT_DATE_FORMAT = "ddd, MMM DD";


// i.e: "Jan 8, 2024"
export const SHORT_DATE_FORMAT = "MMM D, YYYY";
